import { socketService } from '@/services/socketService';
import { useOrderStore } from '@/stores/order';
import { useCds } from '@/composables/useCds';
import { usePos } from '@/composables/usePos';
import { useSystemSettingsStore } from '@/stores/systemSettings';

export function useBroadcastComposable() {
    const { broadcastMessage, registerClient } = socketService;
    const { fetchCdsClientId } = useCds();
    const { fetchPosClientId } = usePos();
    const { getCdsClientId, getPosClientId } = useSystemSettingsStore();
    const { getCurrentOrderState } = useOrderStore();

    const broadcastOrderToCds = async (delay = 0) => {
        const posClientId = await retrievePosClientId();
        const cdsClientId = await retrieveCdsClientId();
        if (posClientId) {
            registerPosClientIdForSocket(posClientId);
            setTimeout(() => {
                broadcastMessage('order', getCurrentOrderState(), cdsClientId);
            }, delay);
        }
    }

    const setupPosSocketConnection = async () => {
        const clientId = await retrievePosClientId();
        if (clientId) {
            registerPosClientIdForSocket()
        }
    }

    const retrievePosClientId = async () => {
        let clientId = getPosClientId();
        if (!clientId) {
            clientId = await fetchPosClientId();
        }
        return clientId;
    }

    const retrieveCdsClientId = async () => {
        let clientId = getCdsClientId();
        if (!clientId) {
            clientId = await fetchCdsClientId();
        }
        return clientId;
    }

    const registerPosClientIdForSocket = (posClientId) => {
        registerClient(posClientId);
    }

    const verifyPosClientIdOnEvent = (uuid) => {
        return typeof uuid === 'string' &&
            uuid.trim().length > 0 &&
            uuid === getPosClientId();
    }

    return {
        broadcastOrderToCds,
        registerPosClientIdForSocket,
        setupPosSocketConnection,
        verifyPosClientIdOnEvent
    }
}